import React from "react";
import ImageNotification from "../../../../assets/img/icons/fcm.png"; // ajusta la ruta según tu estructura

const NotificationContent = ({ title, body, onClick }) => (
    <div
        className="p-3 d-flex align-items-center position-relative"
        style={{
            background: "linear-gradient(135deg, #17416eff, #2e4bc9ff)",
            borderRadius: "1px",
            color: "white",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            margin: "-8px",
            width: "calc(100% + 17px)",
            height: "calc(100% + 17px)",
        }}
    >
        <div
            className="position-absolute d-flex justify-content-center align-items-center"
            style={{
                top: "12px",
                left: "12px",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "rgba(255,255,255,0.2)",
                zIndex: 2,
            }}
        >
            <img
                src={ImageNotification}
                alt="icono"
                style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain",
                }}
            />
        </div>

        <div className="flex-grow-1 ml-5">
            <h5 className="mb-1 font-weight-bold" style={{ color: "#fff" }}>
                {title}
            </h5>
            <p className="mb-2" style={{ color: "rgba(255,255,255,0.9)" }}>
                {body}
            </p>
            <button
                className="btn btn-sm btn-light text-primary font-weight-bold"
                onClick={onClick}
            >
                Ir al sitio
            </button>
        </div>
    </div>
);

export default NotificationContent;
